const inventoryFields = {
  VIC: {
    shelf: 'custom_vic_inventory',
    supplier: 'custom_vic_supplier_inventory',
  },
  NSW: {
    shelf: 'custom_nsw_inventory',
    supplier: 'custom_nsw_supplier_inventory',
  },
  QLD: {
    shelf: 'custom_qld_inventory',
    supplier: 'custom_qld_supplier_inventory',
  },
};

export function serializeDeliveryInventory(item) {
  if (
    !Object.values(inventoryFields).some(({ shelf, supplier }) =>
      [shelf, supplier].some(
        (field) => item?.[field] !== undefined && item[field] !== null && item[field] !== '',
      ),
    )
  ) {
    return '';
  }

  return JSON.stringify(
    Object.fromEntries(
      Object.entries(inventoryFields).map(([warehouse, fields]) => [
        warehouse,
        {
          shelf: Number(item?.[fields.shelf]) || 0,
          supplier: Number(item?.[fields.supplier]) || 0,
        },
      ]),
    ),
  );
}

export function refreshDeliveryEstimates() {
  const { deliveryEstimate } = window.Convermax || {};
  const postcode = deliveryEstimate?.getStoredPostcode?.();

  document.querySelectorAll('.delivery-estimate--card').forEach((element) => {
    const prompt = element.querySelector('.delivery-estimate__prompt');
    const line = element.querySelector('.delivery-estimate__line');
    const range = element.querySelector('.delivery-estimate__range');

    if (!prompt || !line || !range) {
      return;
    }

    if (!postcode) {
      range.textContent = '';
      prompt.hidden = false;
      line.hidden = true;
      element.hidden = false;
      return;
    }

    const estimate = deliveryEstimate?.resolveEstimate?.(element, postcode, 1);
    if (!estimate?.standard) {
      range.textContent = '';
      prompt.hidden = true;
      line.hidden = true;
      element.hidden = true;
      return;
    }

    range.textContent = estimate.standard;
    prompt.hidden = true;
    line.hidden = false;
    element.hidden = false;
  });
}

export function initDeliveryEstimate() {
  document.addEventListener('delivery-estimate:ready', refreshDeliveryEstimates, { once: true });
  document.addEventListener('postcode:updated', refreshDeliveryEstimates);
  window.addEventListener('pageshow', refreshDeliveryEstimates);
  refreshDeliveryEstimates();
}
